export class BillWatchRoutes
{
	static Home: string = '/';

	// AWS
	static AWSList: string = '/aws/list';
	static AWSNew: string = '/aws/new';
	static AWSCopy(id: string)
	{
		return `/aws/${id}/new`;
	}
	static AWSEdit(id: string)
	{
		return `/aws/${id}/edit`;
	}
	static AWSView(id: string)
	{
		return `/aws/${id}/view`;
	}

	// Azure
	static AzureList: string = '/azure/list';
	static AzureNew: string = '/azure/new';
	static AzureCopy(id: string)
	{
		return `/azure/${id}/new`;
	}
	static AzureEdit(id: string)
	{
		return `/azure/${id}/edit`;
	}
	static AzureView(id: string)
	{
		return `/azure/${id}/view`;
	}

	// GCP
	static GCPList: string = '/gcp/list';
	static GCPNew: string = '/gcp/new';
	static GCPCopy(id: string)
	{
		return `/gcp/${id}/new`;
	}
	static GCPEdit(id: string)
	{
		return `/gcp/${id}/edit`;
	}
	static GCPView(id: string)
	{
		return `/gcp/${id}/view`;
	}

	// Rule
	static RuleList: string = '/rule/list';
	static RuleNew: string = '/rule/new';
	static RuleCopy(id: string)
	{
		return `/rule/${id}/new`;
	}
	static RuleEdit(id: string)
	{
		return `/rule/${id}/edit`;
	}
	static RuleView(id: string)
	{
		return `/rule/${id}/view`;
	}
	static RuleBatchSimulation: string = '/rule/batch/simulation';
	static RuleSimulator: string = '/rule/simulator';

	// Usage
	static Usage: string = '/usage'
}